<div class="overlay">
  <div class="reschedule-modal">
    <div class="modal-header">
      <h2>Reschedule Session</h2>
      <span class="close-btn" (click)="close()">&times;</span>
    </div>
    <div class="current-schedule">
      <div class="schedule-header">
        <p class="label">Current Schedule</p>
        <p class="mentor">with {{ mentorName }}</p>
      </div>

      <div class="date-time">
        <mat-icon>event</mat-icon>
        <span>{{ sessionDate }}</span>
        <mat-icon class="ms-2">schedule</mat-icon>
        <span>{{ sessionStartTime }}-{{ sessionEndTime }}</span>
      </div>
      <p class="topic">Career Guidance</p>
    </div>

    <form [formGroup]="rescheduleForm">
      <div class="new-schedule">
        <label for="date">Select New Date</label>
        <input type="date" id="date" />
        <label for="time">Select New Time Slot</label>
        <select id="time">
          <option value="" disabled selected>Choose available time</option>
          <option
            *ngFor="let availableTime of availableTimeSlot"
            [ngValue]="availableTime"
          >
            {{ availableTime.display }}
          </option>
        </select>
        <div class="new-schedule-display" *ngIf="formattedSchedule">
          <p class="new-schedule-text">New Schedule: {{ formattedSchedule }}</p>
        </div>

        <div class="form-group">
          <label>Topics to be Discussed <span class="required">*</span></label>
          <textarea
            formControlName="topic"
            placeholder="e.g. Which topic you want to discuss on..."
          ></textarea>
        </div>
      </div>
    </form>

    <div class="d-flex justify-content-between">
      <button class="cancel-btn" (click)="close()">Cancel</button>
      <button class="btn-add" (click)="postConfirmReschedule()">
        Confirm Reschedule
      </button>
    </div>
  </div>
</div>
